import styled from '@emotion/styled'
import { breakpoint, calcRem, fonts, metrics } from '../../__styling'
import { IconChevronLeftTN } from '../../icons/IconChevronLeftTN/IconChevronLeftTN'
import { IconChevronRightTN } from '../../icons/IconChevronRightTN/IconChevronRightTN'
import { tokens } from '@news-mono/design-tokens'
import React from 'react'

// TheNightly Metrics
const tnMetrics = metrics.thenightly
const tnMargins = tnMetrics.margins

// PerthNow Metrics
const pnMetrics = metrics.perthnow
const pnMargins = pnMetrics.margins
// PerthNow Colors
const pnColors = tokens.perthnow.colors
const pnPalette = pnColors.palette

export const StyledBackNav = styled('div')<{ showOnLargeScreen?: boolean }>(
    ({ showOnLargeScreen = true, theme }) => [
        {
            display: 'flex',
            span: {
                fontWeight: 400,
                lineHeight: '150%',
                cursor: 'pointer',
            },
            svg: { cursor: 'pointer' },
            marginBottom: calcRem(tnMargins.sm),
            width: 'fit-content',

            [breakpoint('sm')]: {
                display: showOnLargeScreen ? 'flex' : 'none',
            },
        },
        // PerthNow Styling
        theme.kind === 'perthnow' && {
            gap: calcRem(4),

            span: {
                fontFamily: theme.fonts.sansSerif,
                fontSize: calcRem(16),
                lineHeight: calcRem(16),

                color: pnPalette.greyWeak,

                display: 'flex',
                alignItems: 'center',
            },
        },
    ],
)

export const StyledIconChevron: React.FC<{
    direction?: 'left' | 'right'
    color?: string
}> = ({ direction = 'right', color }) => {
    return direction === 'right' ? (
        <StyledIconChevronRight color={color} />
    ) : (
        <StyledIconChevronLeft color={color} />
    )
}

export const StyledIconChevronRight = styled(IconChevronRightTN)(
    ({ theme }) => ({
        height: calcRem(tnMargins.m2l),
        width: calcRem(tnMargins.m2l),
    }),
)

export const StyledIconChevronLeft = styled(IconChevronLeftTN)(({ theme }) => [
    {
        height: calcRem(tnMargins.m2l),
        width: calcRem(tnMargins.m2l),
    },
])

export const StyledMainScreen = styled('div')<{ show?: boolean }>(
    ({ show, theme }) => [
        {
            width: '100%',
            display: show ? 'block' : 'none',
            padding: calcRem(tnMargins.xxl, 0, 0, 0),
            fontFamily: theme.fonts.sansSerif,

            h2: {
                fontSize: calcRem(40),
                fontWeight: 700,
                lineHeight: calcRem(48),
                margin: calcRem(0, 0, 0, 0),

                '&.bottom-header': {
                    marginBottom: tnMargins.lg,
                },
            },
            h4: {
                color: tokens.thenightly.colors.text.tertiary,
                fontSize: calcRem(16),
                fontWeight: 400,
                lineHeight: calcRem(24),
                margin: 0,

                '&.bottom-header': {
                    marginTop: tnMargins.sm,
                    marginBottom: tnMargins.lg,
                },
            },

            [breakpoint('sm')]: {
                display: 'block',
                padding: calcRem(64, 0, 64, tnMargins.m2l),
                h2: {
                    fontSize: calcRem(45),
                },
            },

            [breakpoint('lg')]: {
                padding: calcRem(
                    tnMargins.xxxxl,
                    0,
                    tnMargins.xxxxl,
                    tnMargins.m2l,
                ),
                h2: {
                    fontSize: calcRem(51),
                    lineHeight: calcRem(56),
                },
            },
        },
        // PerthNow Styling
        theme.kind === 'perthnow' && {
            padding: 0,

            h2: {
                fontSize: calcRem(30),
                lineHeight: calcRem(32),
                fontWeight: 700,
                fontFamily: theme.fonts.sansSerifCond,
                color: pnPalette.blackShade[85],

                '&.bottom-header': {
                    marginBottom: calcRem(16),
                },
            },
            h4: {
                '&.bottom-header': {
                    marginBottom: calcRem(16),
                },
            },

            [breakpoint('sm')]: {
                padding: 0,

                // Overriding value
                h2: {
                    fontSize: calcRem(36),
                    lineHeight: calcRem(40),
                },
            },
            [breakpoint('lg')]: {
                padding: 0,

                h2: {
                    fontSize: calcRem(36),
                    lineHeight: calcRem(40),
                },
            },
        },
    ],
)
